import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import api from 'api';
import { toast } from 'react-toastify';
import { actions } from 'redux/reducers';
import './login.scss';

function Login() {
  const navigation = useNavigate();
    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = (data: any) => {
    //   console.log("Before call:", data);
      api.user.login(data.Email, data.Password)
        .then(rData => {          
            // console.log(rData);
            localStorage.AccessToken = rData.JwtToken;
            dispatch(actions.user.set(rData));
            navigation("/dashboard");
        })
        .catch(err => {
            toast.error(err.toString());
        })
    }
    console.log(errors);
    const dispatch = useDispatch();
    useEffect(() => {
        localStorage.removeItem("AccessToken");
        dispatch(actions.user.logout());
    }, [dispatch])

    return (
        <div id="login" className="container">
            <div>
                <img src={`${process.env.PUBLIC_URL}/img/logo.svg`} alt="Newsclip Logo" />
            </div>
            <div>
                <h2>LOGIN</h2>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <input type="email" placeholder="Email" {...register("Email", {required: true})} />
                  <input type="password" placeholder="Password" {...register("Password", {required: true})} />

                  <button type="submit"> SUBMIT </button>
                  <Link to="/forgot-password">FORGOT PASSWORD</Link>
                </form>
            </div>
        </div>
    )
}

export default Login;